export enum ModeSwitch {
  CRANE = 'CraneMode',
  AUTOMATIC = 'AutomaticMode',
  SERVICE = 'ServiceMode',
  NONE = 'none'
}
